import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { SaleFormService } from '@app/features/sales/add-sale/steps/sale-form.service';
import { SessionService } from '@src/app/shared/services/session.service';
import { WarrantyActivationFormService } from '@app/features/warranties/activate-warranty-process/steps/warranty-activation-form.service';
import { CompanyResponse } from '@src/app/shared/backend/clients';

@Component({
    selector: 'app-activate-warranty-process',
    templateUrl: './activate-warranty-process.component.html',
    styleUrl: './activate-warranty-process.component.scss',
    host: {
        class: 'app-activate-warranty-process'
    },
    standalone: false
})
export class ActivateWarrantyProcessComponent implements OnInit {

  steps: any[] = [];
  currentStepIndex: number = 0;
  saleId: any;
  company: CompanyResponse = {}

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private session: SessionService,
    private saleFormService: SaleFormService,
    private warrantyActivationFormService: WarrantyActivationFormService
  ) { }

  async ngOnInit() {
    this.company = await this.session.getCompanyData();
    this.initSteps();

    // activation coming after Sale -> redirect to warranty Code step
    this.route.queryParams.subscribe(params => {
      this.saleId = params['saleId'];
      if (this.saleId) {
        const saleFormData = this.warrantyActivationFormService.getAllData();
        this.currentStepIndex = 3;
      }
    });
  }

  updateSteps() {
    this.steps = [
      { label: this.translate.instant('WARRANTY_ACTIVATION.STEP_SELECT_RETAILER'), component: 'select-retailer' },
      { label: this.translate.instant('WARRANTY_ACTIVATION.STEP_ACTIVATION_METHOD'), component: 'activation-method'},
      { label: this.translate.instant('WARRANTY_ACTIVATION.STEP_FIND_SERIAL_REF'), component: 'find-serialnumber'},
      ...(!this.company.isPrepaired ? [ { label: this.translate.instant('WARRANTY_ACTIVATION.STEP_WARRANTY_CODE'), component: 'warranty-code'}] : []),
      { label: this.translate.instant('WARRANTY_ACTIVATION.STEP_ACTIVATION'), component: 'activation'},
      { label: this.translate.instant('WARRANTY_ACTIVATION.STEP_SUMMARY'), component: 'summary'}
    ];
  }

  nextStep() {
    if (this.currentStepIndex < this.steps.length -1) {
      this.currentStepIndex++;
    }
  }

  onPreviousStep() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
    }
  }

  getStepsCounter() {
    return this.steps.length;
  }

  initSteps() {
    this.updateSteps();
    this.currentStepIndex = 0;
  }
}
